// extracted by mini-css-extract-plugin
export var backgroundImage = "splash-module--backgroundImage--4f9b4";
export var splashBackground = "splash-module--splashBackground--3fda6";
export var splashText = "splash-module--splashText--59c57";
export var textOverlay = "splash-module--textOverlay--4fd91";